<template lang="pug">
study-result-detail-list.study-result-detail(
  :moveReturnEvent='moveReturnEvent',
  :resultDetailTitle='resultDetailTitle',
  :studyResultDetailScore='studyResultDetailScore',
  :movieButtonEvent='movieButtonEvent',
  :showMovieButton='showMovieButton',
  :studyResultDetails='studyResultDetails',
  :studyAdviceMessage='studyAdviceMessage'
)
  template(#returnButtonText) 戻る
  template(#titleLabel) の成績詳細
  template(#totalScoreHeader) 合計
  template(#knowledgeScoreHeader) 知識・技能
  template(#thinkingScoreHeader) 思考・判断・表現
  template(#scoreLabel) 得点
  template(#averageLabel) 平均点
  template(#movieButtonText) 解説動画を見る
  template(#tableProblemNumberHeader) 大問番号
  template(#tableQuestionNumberHeader) 小問番号
  template(#tableCorrectSymbolHeader) 正誤
  template(#tableCorrectRateHeader) 正答率
  template(#studyAdviceTitle) 今回の結果について
</template>

<script lang="ts">
import { Component, Mixins } from 'vue-property-decorator'
import StudyResultDetailList from '@/components/templates/student/StudyResultDetailList.vue'
import { StudyResultDetailType, StudyResultDetailScore } from '@/models/studyResultDetailModel'
import { StudyResultUtils } from '@/utils/StudyResultUtils'
import StudentStudyResultDetailApi from '@/mixins/api/student/StudentStudyResultDetailApi'

/**
 * テスト結果詳細画面
 */
@Component({
  components: {
    StudyResultDetailList,
  },
})
export default class StudyResultDetail extends Mixins(StudentStudyResultDetailApi) {
  // 紙テスト結果ID
  private get paperTestId(): number {
    return Number(this.$route.params.paperTestId)
  }

  // 結果詳細タイトル
  private resultDetailTitle = ''

  // テスト結果詳細得点情報
  private studyResultDetailScore: StudyResultDetailScore | null = null

  // 結果詳細一覧
  private studyResultDetails: StudyResultDetailType[] = []

  // 学習アドバイスメッセージ
  private studyAdviceMessage = ''

  // 動画URL
  private movieUrl = ''

  /**
   * [Vue] 画面読み込み時：初期処理
   */
  private async mounted(): Promise<void> {
    // 結果詳細情報を取得
    this.$loading.start()

    const apiResponse = await this.getStudentStudyResultDetail(this.paperTestId)
    this.resultDetailTitle = StudyResultUtils.getStudyResultDetailTitle(apiResponse)
    this.studyResultDetailScore = StudyResultUtils.buildStudyResultDetailScore(apiResponse)
    this.studyResultDetails = StudyResultUtils.buildStudyResultDetails(apiResponse)
    this.studyAdviceMessage = StudyResultUtils.getAdviceMessage(apiResponse)
    this.movieUrl = StudyResultUtils.getMovieUrl(apiResponse)

    this.$loading.complete()
  }

  // 戻るボタン押下時イベント
  private moveReturnEvent() {
    this.$router.push({ name: 'StudentStudyResult' })
  }

  // 動画を見るボタン押下時イベント
  private movieButtonEvent() {
    // 別タブで動画URLを開く
    window.open(this.movieUrl, '_blank')
  }

  // 動画を見るボタン表示フラグ
  private get showMovieButton() {
    // 動画URLが存在する場合のみボタンを表示
    return !!this.movieUrl
  }
}
</script>
